import { InteractionInterface } from './InteractionInterface';
import richTextRender from '../components/interactions/richTextRender.vue';

export class RichTextInteraction extends InteractionInterface {
  constructor(question, testData) {
    super(question);
    this.testData = testData;
    this.userAnswer = '';
  }

  render() {
    return {
      component: richTextRender,
      props: {
        question: this.question,
        testData: this.testData,
      },
    };
  }

  restoreAnswer(savedAnswer) {
    this.userAnswer = savedAnswer;
  }

  calculateScore(userAnswer) {
    // Score calculation logic - can be implemented later
    return 0;
  }

  saveAnswer() {
    return this.userAnswer;
  }
}
